export default __webpack_public_path__ + "static/media/black_hole.384eb7ff.jpg";